/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class CodeDiffIcon extends BaseIcon {
  getChildren = () => [
    <polygon fill={ this.getColor() } points="16.09 20 14 17.89 19.83 12 14 6.11 16.09 4 24 12 16.09 20"/>,
    <polygon fill={ this.getColor() } points = "7.91 20 10 17.89 4.17 12 10 6.11 7.91 4 0 12 7.91 20" />
  ]
  getViewBox = () => '0 0 24 24'
}
